import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { T as Text } from './Text-BCmEgJBp.js';
import { I as Icon } from './Icon-8KKXFsxm.js';

var styles = {"hasValidationMessage":"sc-bFJieXBA-","message":"xybhC5Y6mk4-"};

function InputValidation({ message }) {
    const messages = [message];
    const variants = {
        slideOut: { y: "5%", opacity: 0 },
        slideIn: { y: 0, opacity: 1 },
    };
    return (React.createElement(React.Fragment, null, messages && messages.length > 0 && (React.createElement(AnimatePresence, { mode: "wait" }, messages.map(msg => (React.createElement(motion.div, { key: `validation-${msg}`, variants: variants, initial: "slideOut", animate: "slideIn", exit: "slideOut", transition: { duration: 0.2 } },
        React.createElement("div", { className: styles.message, "aria-live": "assertive", role: "alert", tabIndex: 0 },
            React.createElement(Icon, { name: "alert", size: "small", color: "critical" }),
            React.createElement(Text, { size: "small", variation: "error" }, msg)))))))));
}

export { InputValidation as I };
